import { BaseClient } from 'src/common-services/clients/base-client'
import { LocalBusinessesResponseBody } from 'src/common-services/types/local-businesses-types'
import { Unbranded } from 'src/common-services/types/unbranded-types'

export class LocalBusinessesClient extends BaseClient {
  searchLocalBusinesses(query: string, numOfRecords: number = 10): Promise<LocalBusinessesResponseBody> {
    return this.call<any>('/local-businesses/search', 'POST', { data: { query, numOfRecords } })
  }
  searchUnbranded(latitude: number, longitude: number, radius: number): Promise<Unbranded[]> {
    return this.call<any>('/local-businesses/search-unbranded', 'POST', { data: { latitude, longitude, radius } })
  }
}
